import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";
import { ProjectService } from './project/project.service';

@Injectable({
  providedIn: 'root'
})
export class TdgService {
  private projectId = '';
  private selectedSchemas: any = [];
  private taskId = '';
  private sessionId = '';
  private retrievedSchemas: any = [];
  private messages: any = [{ text: 'Hi!, I am here to help you out' }];
  private customData: any = {};
  private tableData: any = {};
  private persistedData: any = {};
  private tabStatus: any = [];
  private columns: any = [];
  private isEditable = false;
  private customTableId = '';
  private selectedTestSuite: any = new BehaviorSubject<any>(null);
  private fileName: string = '';
  private file:any = {
    file:null,
    type:"SQL"
  };

  constructor(private readonly projectService: ProjectService) { }

  ngOnInit() {
    this.projectService.getProjectId().subscribe((response: any) => {
      this.setProjectId(response);
    });
  }

  clearAll() {
    this.selectedSchemas = [];
    this.taskId = '';
    this.sessionId = '';
    this.retrievedSchemas = [];
    this.messages = [{ text: 'Hi!, I am here to help you out' }];
    this.customData = {};
    this.columns = [];
    this.isEditable = false;
    this.customTableId = '';
    this.tableData = {};
    this.persistedData = {};
    this.tabStatus = [];
    this.selectedTestSuite = [];
    this.fileName = '';
    this.file = {
      file:null,
      type:"SQL"
    };
  }

  setProjectId(projectId: string) {
    this.projectId = projectId;
  }

  getProjectId() {
    return this.projectId;
  }

  setSelectedFile(file: string) {
    this.file = file;
  }

  getSelectedFile() {
    return this.file;
  }

  setSelectedFileName(name: string) {
    this.fileName = name;
  }

  getSelectedFileName() {
    return this.fileName;
  }

  setSelectedSchemas(schemas: any) {
    this.selectedSchemas = schemas;
  }

  getSelectedSchemas() {
    return this.selectedSchemas;
  }

  setSelectedTestSuite(suite: any) {
    this.selectedTestSuite.next(suite);
  }

  getSelectedTestSuite() {
    return this.selectedTestSuite.asObservable();
  }

  setTaskId(taskId: string) {
    this.taskId = taskId;
  }

  getTaskId() {
    return this.taskId;
  }

  setRetrievedSchemas(schemas: any[]) {
    this.retrievedSchemas = schemas;
  }

  getRetrievedSchemas() {
    return this.retrievedSchemas;
  }

  setSessionId(sessionId: string) {
    this.sessionId = sessionId;
  }

  getSessionId() {
    return this.sessionId;
  }

  setMessages(message: any) {
    this.messages = message;
  }

  getMessages() {
    return this.messages;
  }

  setCustomData(customData: any) {
    this.customData = customData;
  }

  getCustomData() {
    return this.customData;
  }

  setColumns(columns: any[]) {
    this.columns = columns;
  }

  getColumns() {
    return this.columns;
  }

  setIsEditable(isEditable: boolean) {
    this.isEditable = isEditable;
  }

  getIsEditable() {
    return this.isEditable;
  }

  setCustomTableId(customTableId: any) {
    this.customTableId = customTableId;
  }

  getCustomTableId() {
    return this.customTableId;
  }

  getFormatedResponse(arr: any[],isAgentic?:boolean) {
    const checkboxColumn = {
      display_name: '',
      key: 'checkbox',
      showExpand: false,
      _config: {
        type: 'checkbox',
        displayInColumn: true
      }
    };
    
    arr.forEach((schema: any) => {
      if(schema.tables?.length) {
        schema.tables.forEach((table: any) => {
          let clonedColumns = table.columns;
          let formattedColumns: any = [];
          const piiColumns: string[] = [
            ...(table.piiColumns ?? []),
            ...(table.pii_columns ?? []),
            ...(schema.piiColumns ?? []),
            ...(schema.pii_columns ?? []),
          ];
          // if(isAgentic){
          //   formattedColumns.push(checkboxColumn);
          // }
          clonedColumns.forEach((column: any, index: number) => {
            const columnKey = typeof column === 'string' ? column : column?.key;
            let col: any = {
              key: columnKey,
              display_name: typeof column === 'string' ? column : (column?.display_name ?? columnKey)
            };
            if (columnKey && piiColumns.includes(columnKey)) {
              col._config = {
                type: 'password',
                classNames: 'border-0 bg-transparent',
              };
            }
            if(clonedColumns.length > 6) {
              col.headerStyles = {
                width: '180px !important'
              }
            }
            formattedColumns.push(col);
          });
          table.rawData.forEach((row: any, rowIndex: number) => {
            if (row && typeof row === 'object' && !Array.isArray(row)) {
              return;
            }
            const cells = Array.isArray(row) ? row : String(row ?? '').split(',');
            const record: any = {};
            table.columns.forEach((column: any, index: number) => {
              const columnKey = typeof column === 'string' ? column : column?.key;
              const cell = cells[index];
              record[columnKey] = typeof cell === 'string' ? cell.replaceAll("'", '') : cell;
            });
            table.rawData[rowIndex] = record;
          });
          table.columns = formattedColumns;
          // table.rawData = formattedRow;
        });
      }
    });
    return arr;
  }

  getQuotedString(text: any) {
    if(isNaN(text)) {
      return `'${text}'`;
    } else {
      return text;
    }
  }

  triggerDownload(blob: Blob, fileName: string) {
    // Create an object URL for the Blob
    const url = window.URL.createObjectURL(blob);

    // Create a temporary anchor element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName; // Specify the file name for the download

    // Programmatically click the anchor to trigger the download
    document.body.appendChild(a);
    a.click();

    // Clean up
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url); // Free up memory by revoking the URL
  }

  setValidatedTable(data: any) {
    this.tableData = data;
  }

  getValidatedTable() {
    return this.tableData;
  }

  setPersistedTable(data: any) {
    this.persistedData = data;
  }

  getPersistedTable() {
    return this.persistedData;
  }

  setTabStatus(data: any) {
    this.tabStatus = data;
  }

  getTabStatus() {
    return this.tabStatus;
  }
  
}
